import { CommandBarButton, IconButton } from "@fluentui/react";
import DetailsTable from "../../../../Table/DetailsTable";
import FeatureSummary from "../../../../Util/FeatureSummary";
import DefaultContextualMenu from "../../../../Table/DefaultContextualMenu";

function CobrandTagsDefaultTable({ cobrandTags, editOnClick, deleteOnClick, createOnClick, setSelectedCobrandTag }) {
    const columns = [
        {
            key: "toolbar",
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <DefaultContextualMenu
                    editOnClick={() => editOnClick(item.cobrandTagId)}
                    deleteOnClick={() => deleteOnClick()}
                />
            ),
        },
        {
            name: "CobrandTagId",
            fieldName: "cobrandTagId",
            key: "coBrandTagID",
            minWidth: 110,
            maxWidth: 110,
            isResizable: true,
            isSorted: true,
            isSortedDescending: false,
        },
        {
            name: "Name",
            fieldName: "name",
            key: "name",
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isSortedDescending: false,
        },
        {
            name: "Description",
            fieldName: "description",
            key: "description",
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isSortedDescending: false,
        },
    ];

    return (
        <>
            <DetailsTable
                items={cobrandTags}
                columns={columns}
                mainColumn={"coBrandTagID"}
                CommandBar={
                    <CommandBarButton iconProps={{ iconName: "Add" }} text="Create" onClick={() => createOnClick()} />
                }
                selectionHook={(items) => setSelectedCobrandTag(items && items[0])}
            />
            <FeatureSummary
                label="About Cobrand Tags"
                summary="This table displays all cobrand tags, including their name and description. You can add, edit, or delete tags. The Cobrand Tags feature allows admins to organize and manage tags for cobrands."
            />
        </>
    );
}

export default CobrandTagsDefaultTable;
